import { Button } from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import { FEED_ITEM_LIST } from 'src/constants/queryKeys';
import { PATH_DASHBOARD } from 'src/routes/paths';
import useFormsModalStore from 'src/store/forms';

const FeedItemTableBreadcrumb = ({ feedDetails, appSectionDetails }) => {
  const { setModal } = useFormsModalStore();
  const { projectId, appSectionKeyOrder, appSectionId } = useParams();

  return (
    <HeaderBreadcrumbs
      heading="فهرست محتوا ها"
      links={[
        { name: 'داشبورد', href: PATH_DASHBOARD.general.home },
        { name: 'فهرست بخش ها', href: PATH_DASHBOARD.general.appSectionList(projectId) },
        {
          name: `بسته های نمایش محتوایی ${appSectionDetails?.ApplicationSectionLable}`,
          href: PATH_DASHBOARD.general.projectFeedList(projectId, appSectionKeyOrder, appSectionId),
        },
        { name: `محتوا های بسته‌ی ${feedDetails?.FeedTitle}`, href: null },
      ]}
      action={
        <Button
          variant="contained"
          component={RouterLink}
          startIcon={<Iconify icon={'eva:plus-fill'} />}
          onClick={() => setModal({ isOpen: true, data: null, type: FEED_ITEM_LIST, title: 'ایجاد محتوای بسته' })}
        >
          محتوا جدید
        </Button>
      }
    />
  );
};

export default FeedItemTableBreadcrumb;
